import * as types from './mutation-types'
import api from '../api'

const state = {
	counter: [
		{
			online_users: 0,
			offline_users: 0,
			registered_users: 0
		}
	],

	countries: [],
	changePageLoading: false,

	counterError: {},
	counterLoading: false,

	dashbordData: {},
	dashbordDataError: {},
	dashbordDataLoading: false
}

const mutations = {

	[types.SET_COUNTER_LOADING] (state) {
		state.counterLoading = true
	},

	[types.SET_COUNTER_SUCCESS] (state, payload) {
		state.counter = payload.data
		state.countries = payload.data.upmood_population.data
		state.counterLoading = false
	},

	[types.SET_COUNTER_FAIL] (state, payload) {
		state.counterError = payload.data
		state.counterLoading = false
	},

	[types.CHANGE_PAGE_LOADING] (state) {
		state.changePageLoading = true
	},

	[types.CHANGE_PAGE_SUCCESS] (state, payload) {
		state.counter.upmood_population = payload.data.upmood_population
		state.countries = [...state.countries, ...payload.data.upmood_population.data]
		state.changePageLoading = false
	},

	[types.CHANGE_PAGE_FAIL] (state, payload) {
		state.changePageLoading = false
	},

	deactivate () {
		state.counter = {}
		state.population = {}
	}

}

const actions = {

	async getCounter ({ commit }) {
		commit(types.SET_COUNTER_LOADING)

		const { data, status } = await api('post', 'dashboard/counter')
		if (status) {
			commit(types.SET_COUNTER_SUCCESS, data)
			return
		}

		commit(types.SET_COUNTER_FAIL, data)
	},

	async loadMore ({ commit }, payload) {
		commit(types.CHANGE_PAGE_LOADING)

		const { data, status } = await api('post', 'dashboard/counter' + payload)
		if (status) {
			commit(types.CHANGE_PAGE_SUCCESS, data)
			return
		}

		commit(types.CHANGE_PAGE_FAIL, data)
	}
}

const getters = {
	getCounter: state => state.counter,
	// getCounterLoading: state => state.counterLoading,
	getAccountCancellation: state => state.dashbordData.account_cancellation,
	getInquiries: state => state.dashbordData.inquiries,
	getReports: state => state.dashbordData.reports,
	getDashboardLoading: state => state.counterLoading,
	getChangePageLoading: state => state.changePageLoading,
	getCountries: state => {
		const intToHSL = (value, total = 193) => {
			const percentage = (value / total).toFixed(2)
			const hue = Math.min(360, Math.round(360 * percentage))
			const hsl = `hsl(${hue}, 60%, 50%)`
			return hsl
		}

		// const dummy = [
		// 	{ country: 'Philippines', 'sum(online+offline)': 10, average_emotion: 'Pleasant' },
		// 	{ country: 'China', 'sum(online+offline)': 20, average_emotion: 'Pleasant' },
		// 	{ country: 'Greenland', 'sum(online+offline)': 200, average_emotion: 'Pleasant' },
		// 	{ country: 'Japan', 'sum(online+offline)': 100, average_emotion: 'Pleasant' }
		// ]

		if (state.countries.length > 0) {
			// const length = dummy.length
			// const populationData = dummy
			const length = state.countries.length
			const populationData = state.countries
			const withColor = populationData.map((i, index) => {
				if (i.country) i.color = intToHSL(index + 1, length)
				return i
			})

			state.countries = withColor

			return state.countries
		}

		return state.countries
	}
}

export default {
	state,
	mutations,
	actions,
	getters,
	namespaced: true
}
